import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { ApiResponse } from '../../models/api-response';
import { useLoadData } from '../../hooks/useLoadData';
import { SelectConfig, SelectResult } from './select-chain.component';
import { LoadingIndicator } from '../loading-indicator.component';

interface SelectChainFilterProps {
  value: SelectResult;
  config: SelectConfig;
  onSelect: (selectedItem: SelectResult) => void;
}

export const SelectItem = ({
  value,
  config: { optionsLabelKey, optionsValueKey, title, getQueryKeyConfig },
  onSelect,
}: SelectChainFilterProps) => {
  const { data, isLoading, isFetching } = useLoadData<ApiResponse<any[]>>(getQueryKeyConfig(value));

  return (
    <FormControl fullWidth>
      <InputLabel size="small" id="demo-simple-select-label">
        {title}
      </InputLabel>
      <LoadingIndicator isLoading={isLoading || isFetching} />
      <Select
        size="small"
        labelId="demo-simple-select-label"
        id="demo-simple-select"
        value={value[optionsValueKey]}
        label={title}
        onChange={(event) => onSelect({ [optionsValueKey]: event.target.value })}
      >
        {data ? (
          data?.data.map((o: any) => (
            <MenuItem key={`${o[optionsLabelKey]}-${o[optionsValueKey]}`} value={o[optionsValueKey]}>
              {o[optionsLabelKey]}
            </MenuItem>
          ))
        ) : (
          <MenuItem key={`EMPTY`}>No data Loaded</MenuItem>
        )}
      </Select>
    </FormControl>
  );
};
